import type { TextConfig } from "konva/lib/shapes/Text";

export type FontPreset = {} & TextConfig;

export const FONT_PRESET_OPTIONS: FontPreset[] = [
  {
    fontFamily: "Kablammo",
    fill: "white",
    align: "left",
    strokeWidth: 0,
    stroke: "black",
  },
];
